/* eslint-disable */
import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import LoaderGraphic from '../../utils/LoaderGraphic';
import FirmReportNaicsAnalysis from './FirmReportNaicsAnalysis';
import DashboardViewControls from '../utils/DashboardViewControls';
import ParentDashboard from '../ParentDashboard';
import PRAnalysis from '../PRAnalysis';
import MoneyReportSheets from '../report_components/MoneyReportSheets';
import { getDashBoardPagesPDF } from '../PDFDashboardHelper';
import TextEditor from '../TextEditor';
import TextEditorPDF from '../TextEditorPDF';
import moment from 'moment';

const notePermissions = {
  'private': 'Private',
  'view_only': 'All Can View Only',
  'edit_and_view': 'All Can Edit and View'
}


const FirmReport = React.forwardRef((props, ref) => {
    const navbar = window.navbar.navbar;
    const firmName = props.data.firm_name;
    const firmLogo = props.data.firm_logo;

    const CoverPage = () => {
        const reportTitle = 'Firm Report';
        const todayDate = moment(Date.now()).format('LL');

        return (
            <div className="portrait-view cover-page-pdf">
                <div className="cover-page-top-section" />
                <div className="cover-page-info">
                    <div>
                    <div className="img-title-page-print">
                        {firmLogo ? <img src={firmLogo} alt="" /> : null}
                    </div>
                    <h1>{reportTitle}</h1>
                    <div className="cp-report-info">
                        <p>{firmName}</p>
                        <p style={{ textTransform: 'uppercase' }}>{todayDate}</p>
                    </div>
                    </div>
                </div>
                <div className="cover-page-bottom-section">
                    <p>Powered by Peerview Data</p>
                </div>
            </div>
        );
    }

    const NAICSCoverPage = (props) => {
        const reportTitle = props.report_name;
        const todayDate = moment(Date.now()).format('LL');

        return (
            <div className="portrait-view cover-page-pdf">
                <div className="cover-page-top-section" />
                <div className="cover-page-info">
                    <div>
                    <div className="img-title-page-print">
                        {firmLogo ? <img src={firmLogo} alt="" /> : null}
                    </div>
                    <h1>{reportTitle}</h1>
                    <div className="cp-report-info">
                        <p>{firmName}</p>
                        <p style={{ textTransform: 'uppercase' }}>{todayDate}</p>
                    </div>
                    </div>
                </div>
                <div className="cover-page-bottom-section">
                    <p>Powered by Peerview Data</p>
                </div>
            </div>
        );
    }

    const getPracticeDataForTab = (tab) => {
        const key = tab?.details?.naics_string || tab?.details?.code;
        if (!key) return null;

        return props.practiceData?.[key] || null
    };

    const getPracticeTableForTab = (tab) => {
        const key = tab?.details?.naics_string || tab?.details?.code;
        if (!key) return null;

        return props.practiceTableState?.[key] || null
    };

    const renderNotesPermission = (tab) => {
        if (tab?.permissions) {
            const permissionText = notePermissions[tab?.permissions]
            return (
                <div className='note-name-permissions'>
                    <div>{`Name: ${tab?.name}`}</div>
                    <div>{`Permissions: ${permissionText}`}</div>
                </div>
            )
        }
    }

  const getReportComponent = (tab, pdf = false) => {
    const practiceReportData = getPracticeDataForTab(tab);
    const practiceTable = getPracticeTableForTab(tab);

    switch (tab.report) {
        case 'cover_page':
            return <CoverPage key="cover_page" />;
            break;
        case 'naics_cover_page':
            return <NAICSCoverPage key={tab.key} report_name={tab.name} />;
            break;
        case 'naics-analysis':
            return (
                <FirmReportNaicsAnalysis
                    key={pdf ? `pdf-${tab.id}` : tab.id}
                    naics_averages={props.data.naics_averages}
                    pieTopLevelArr={props.data.pieTopLevelArr}
                    child_count={props.data.child_count}
                    drillup={props.data.drillup}
                    drillup_text={props.data.drillup_text}
                    selectedFilters={props.selectedFilters}
                    setSelectedFilters={props.setSelectedFilters}
                    handleSubmit={props.handleSubmit}
                    sortConfig={props.naicsSortConfig}
                    onSortChange={props.handleNaicsSortChange}
                    pdf={pdf}
                />
            );
            break;
        case 'client-analysis':
            if (practiceReportData) {
                return (
                    <PRAnalysis
                        {...practiceReportData}
                        key={pdf ? `pdf-${tab.id}` : tab.id}
                        tab='client-analysis'
                        pdf={pdf}
                        handleFocusedClients={props.handleFocusedClients}
                        handleTableChanges={props.handleTableChanges}
                        naicsString={tab?.details?.naics_string}
                        selectedFilters={tab?.details}
                        setSelectedFilters={props.setSelectedFilters}
                        tableState={practiceTable}
                        user_focused_clients={practiceReportData.user_focused_clients}
                    />
                );
            } else {
                return null;
            }
            break;
        case 'pnl':
            if (practiceReportData) {
                return (
                    <MoneyReportSheets
                        key={pdf ? `pdf-${tab.id}` : tab.id}
                        pdf={pdf}
                        clientName={'Practice Report'}
                        commonKey='revenue'
                        filters={tab?.details}
                        n={practiceReportData.child_count}
                        page={'practice'}
                        sheet='pnl'
                        title='Profit &#38; Loss'
                        tree={practiceReportData.tree}
                        year={practiceReportData.year}
                        yearRange={practiceReportData.yearRange}
                        calcs={practiceReportData.report_metrics}
                    />
                )
            } else {
                return null;
            }
            break;
        case 'balance-sheet':
            if (practiceReportData) {
                return (
                    <MoneyReportSheets
                        key={pdf ? `pdf-${tab.id}` : tab.id}
                        pdf={pdf}
                        clientName={'Practice Report'}
                        commonKey='assets'
                        filters={tab?.details}
                        n={practiceReportData.child_count}
                        page={'practice'}
                        sheet='balance_sheet'
                        title='Balance Sheet'
                        tree={practiceReportData.tree}
                        year={practiceReportData.year}
                        yearRange={practiceReportData.yearRange}
                        calcs={practiceReportData.report_metrics}
                    />
                )
            } else {
                return null;
            }
            break;
        case 'naics-dashboard':
        case 'dashboard':
            let layout = props.dashboard.layout;
            let data = props.data;
            let layoutChange = props.handleOnLayoutChange;
            let toggleChange = props.handleToggleDraggable

            if (tab.report === 'naics-dashboard' && practiceReportData) {
                let dashboardView = props.naicsDashLayouts.find((c) => c.key === tab.key);
                layout = dashboardView?.dashboard_layout || [];
                data = practiceReportData;
                data.rankingData = data.snapshot_info;
                layoutChange = props.handleCustomLayoutChange;
                toggleChange = props.handleToggleDraggableCustom;
            }

            if (pdf && data && layout) {
                const dashboardPages = getDashBoardPagesPDF(layout);
                return dashboardPages.map((dashboardItems, index) => (
                    <div key={`firm-dashboard-pdf-${index}`} className='portrait-view'>
                      <div className='money-pdf-portrait'>
                        <div>
                          <ParentDashboard
                            tabKey={tab.key}
                            customKey={tab.key}
                            customLayout={tab.report === 'naics-dashboard'}
                            clientData={data.user_focused_clients_info}
                            calculations={data.dashboard_calculations}
                            rankingData={data.rankingData}
                            dashboardLayout={dashboardItems}
                            handleOnLayoutChange={layoutChange}
                            handleToggleDraggable={toggleChange}
                            page={'practice'}
                            year={data.year}
                            yearRange={data.yearRange}
                            pdf
                          />
                        </div>
                      </div>
                    </div>
                ))
            }
            // noMultipleViews is for the NAICS sub tabs' dashboards because they will only have one dashboard per NAICS

            return (
                 <>
                    {(tab.report === 'dashboard' && tab.active_view) && (
                        <DashboardViewControls
                            report={'practice'}
                            noMultipleViews={tab.active_view}
                            dashboardViewModalState={props.dashboardViewModalState}
                            getDashBoardView={props.getDashBoardView}
                            handleDashboardViewModal={props.handleDashboardViewModal}
                        />
                    )}
                    {(tab.active_view) && (
                        <ParentDashboard
                            pdf={pdf}
                            tab={tab}
                            tabKey={tab.key}
                            customKey={tab.key}
                            customLayout={tab.report === 'naics-dashboard'}
                            clientData={data.user_focused_clients_info}
                            calculations={data.dashboard_calculations}
                            rankingData={data.rankingData}
                            dashboardLayout={layout}
                            handleOnLayoutChange={layoutChange}
                            handleToggleDraggable={toggleChange}
                            page={'practice'}
                            year={props.data.year}
                            yearRange={props.data.yearRange}
                        />
                    )}
                 </>
            )
            break;
        case 'generated_firm_notes':
        case 'generated_naics_notes':
            if (props.pdf) {
                const companyNote = props.companyNotes.find(n => n?.id === tab?.active_note_id) || { notes: '' };
                return (
                    <TextEditorPDF
                        key={`${tab.key}-pdf`}
                        companyNotes={companyNote}
                    />
                )
            } else {
                const companyNote = props.companyNotes.find(n => n?.id === tab?.active_note_id) || { notes: '' };
                const generatedNotesVersions = props.generatedNotesByTab[tab?.id] || [];

                return (
                    <>
                        <div className='note-details-div'>
                            {renderNotesPermission(tab)}
                            {generatedNotesVersions && generatedNotesVersions.length > 0
                                ? (
                                <div className='note-select-input-section'>
                                    <button className='table-btn' type='button' onClick={() => props.revertToGeneratedReponse(tab.active_note_id)}>{`Revert to Orginal Response for Number ${companyNote?.generated_version}`}</button>
                                    <div>
                                        <form>
                                            <label htmlFor='company-notes-versions-select'>Versions:</label>
                                            <select id='company-notes-versions-select' value={tab.active_note_id} onChange={(e) => props.handleGenereateNoteChange(e.target.value, tab)}>
                                            {
                                                generatedNotesVersions.map((note) => {
                                                    let createdDate = moment(note.created_at).format("MMMM D, YYYY [at] h:mm A")
                                                    return <option key={`fgn-${note.id}`} value={note.id}>{`Number ${note.generated_version} - ${createdDate}`}</option>
                                                })
                                            }
                                            </select>
                                        </form>
                                    </div>
                                </div>
                                )
                                : null
                            }
                        </div>
                        <TextEditor
                            key={`${tab?.key}-${tab?.active_note_id}-${Math.random()}`}
                            tabInfo={tab}
                            companyNotes={companyNote}
                            activeNoteId={tab.active_note_id}
                            onChangeNotes={props.onChangeNotes}
                            handleGenereateNoteChange={props.handleGenereateNoteChange}
                            revertToGeneratedReponse={props.revertToGeneratedReponse}
                            reportType={tab.report}
                            page={'firm'}
                        />
                    </>
                )
            }
            break;
        case 'firm_notes':
            if (props.pdf) {
                const companyNote = props.companyNotes.find(n => n?.preference_id === tab?.id) || { notes: '' };
                return (
                    <TextEditorPDF
                        key={`${tab.key}-pdf`}
                        companyNotes={companyNote}
                    />
                )
            } else {
                const companyNote = props.companyNotes.find(n => n?.preference_id === tab?.id) || { notes: '' };
                return (
                    <>
                        <div className='note-details-div'>
                            {renderNotesPermission(tab)}
                        </div>
                        <TextEditor
                            key={`${tab.key}-${props.companyNotes.length}`}
                            tabInfo={tab}
                            companyNotes={companyNote}
                            onChangeNotes={props.onChangeNotes}
                            reportType={tab.report}
                            page={'firm'}
                        />
                    </>
                )
            }
            break;
        default:
            break;
    }
  }

  if (props.pdf) {
    let allTabsToDisplay = []
    props.displayPages.forEach(t => {
        if (t.report === 'generated_naics_main_tab' && t?.sub_tabs) {
            allTabsToDisplay = [...allTabsToDisplay, { key: `${t.key}_cover_page`, checked: true, report: 'naics_cover_page', name: t.name }, ...t.sub_tabs]
        } else {
            allTabsToDisplay.push(t)
        }
    })

    return (
        <div ref={ref} className='pdf-print-container'>
            {allTabsToDisplay.filter((tab) => tab.checked).map((tab) => getReportComponent(tab, true))}
        </div>
    )
  }

  const onDragEnd = (result, parentTab) => {
    if (!result.destination || !parentTab?.sub_tabs) return;

    const newSubTabs = Array.from(parentTab.sub_tabs);
    const [movedTab] = newSubTabs.splice(result.source.index, 1);
    newSubTabs.splice(result.destination.index, 0, movedTab);

    props.saveSubTabOrder(newSubTabs);
  };

  const renderAllReports = () => {
    return (
        props.reportsOnTabs.map((tab, i) => {
            if (tab.key === 'dashboard') {
                return <React.Fragment key="dashboard">{getReportComponent(tab)}</React.Fragment>;
            }
            if (tab.report === 'generated_naics_main_tab') {
                return (
                    <div
                        key={tab.key}
                        className={props.activeTab === tab.key ? 'show-section' : 'hide-section'}
                    >
                        <DragDropContext onDragEnd={(result) => onDragEnd(result, tab)}>
                            <Droppable droppableId={`${tab.id}-subtabs`} direction='horizontal'>
                            {(provided) => (
                                <ul
                                    id={`sub-nav-tabs-practice-report`}
                                    className="report-tab-list"
                                    role="tablist"
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    {tab.sub_tabs.map((subTab, index) => {
                                        const styleName = subTab.active_view ? 'sub-report-tab-item sub-active' : 'sub-report-tab-item';
                                        return (
                                            <Draggable key={subTab.key} draggableId={subTab.key.toString()} index={index}>
                                            {(provided) => (
                                                <li
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                key={subTab.key}
                                                className={styleName}
                                                role="presentation"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    props.updateSubTabActiveView(subTab);
                                                }}
                                                >
                                                <span className="tab-name">{subTab.name}</span>
                                                </li>
                                            )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </ul>
                            )}
                            </Droppable>
                        </DragDropContext>
                        {
                            tab.sub_tabs.map(subTab => {
                                if (subTab.report === 'naics-dashboard' && subTab.active_view) {
                                    return <React.Fragment key={subTab.key}>{getReportComponent(subTab)}</React.Fragment>;
                                }

                                return (
                                    <div key={subTab.key} className={subTab.active_view ? 'show-section' : 'hide-section'}>
                                        {getReportComponent(subTab)}
                                    </div>
                                )
                            })
                        } 
                    </div>
                )
            }
            return (
                <div
                    key={tab.key}
                    className={props.activeTab === tab.key ? 'show-section' : 'hide-section'}
                >
                    {getReportComponent(tab)}
                </div>
            );
        })
    )
  }

  if (props.data.year > 0) {
    return (
      <div style={{ opacity: (props.isLoading ? 0.6 : 1) }}>
        <div className='money-content'>
          {props.data.insufficientData
            ? <h1>{props.data.insufficientData}</h1>
            : renderAllReports()
          }
        </div>
      </div>
    )
  } else {
    return (
      <div style={{ 'height': '80vh', 'paddingTop': '30vh' }}>
        <LoaderGraphic />
      </div>
    )
  }
});

export default FirmReport;
